<!-- 作物信息组件 -->
<template>
    <div class="pageContent">
        <CommonRow :title="$t('page.cropInfo.cropImage')">
            <CommonImageCard :src="handleImage(cropInfo.plantImage)" :height="'200px'" />
        </CommonRow>
        <div class="cropItemBox">
            <CommonRow :title="$t('page.cropInfo.cropVariety')">
                <div class="cropItemVariety">
                    <i class="s-icon s-icon-zhongzi cropItemIcon"></i>
                    <div class="cropItemText ellipsis">{{ cropInfo.variety || "-" }}</div>
                </div>
            </CommonRow>
            <CommonRow :title="$t('page.cropInfo.cropName')">
                <div class="cropItemName">
                    <i class="s-icon s-icon-zhiwu cropItemIcon"></i>
                    <div class="cropItemText ellipsis">{{ cropInfo.name || "-" }}</div>
                </div>
            </CommonRow>
        </div>
        <div class="whiteCard">
            <div class="cropBottomItem">
                <div class="cropBottomItemTitle">{{ $t('page.cropInfo.buyLink') }}</div>
                <div class="cropBottomItemValue" @click="toLink(cropInfo.link)">{{ cropInfo.link || "-" }}</div>
            </div>
            <div class="cropBottomItem">
                <div class="cropBottomItemTitle">{{ $t('page.cropInfo.buyLinkDesc') }}</div>
                <div class="cropBottomItemValue">{{ cropInfo.description || "-" }}</div>
            </div>
            <div class="cropBottomItem">
                <div class="cropBottomItemTitle">{{ $t('page.cropInfo.position') }}</div>
                <div class="cropBottomItemValue" @click="showSheet()">{{ cropInfo.address || "-" }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import CommonImageCard from '../common/commonImageCard.vue';
import { Dialog } from 'vant';
import { CODE_SUCCESS } from '../../utils/constant.js';
import { validateImageUrl, isValidUrl } from '../../utils/index.js';
export default {
    components: {
        CommonImageCard,
    },
    props: {
        info: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            cropInfo: {}, // 作物信息对象
        };
    },
    methods: {
        async refresh() {
            if (!this.info.traceabilityId) {
                this.cropInfo = {};
                return
            }
            this.$toast.loading({
                message: this.$t("common.loading"),
                forbidClick: true,
            });
            try {
                const params = {
                    id: this.info.traceabilityId
                }
                const res = await this.$api.fetchSelectZdFarmTraceabilityByIdToH5(params);
                this.$toast.clear()
                if (res.code != CODE_SUCCESS) {
                    this.$toast.fail(res.msg);
                } else {
                    this.cropInfo = res.data || {};
                }
            } catch (error) {
                this.$toast.clear()
                console.error("错误", error);
            }
        },
        toLink(link = "") {
            if (isValidUrl(link)) {
                Dialog.confirm({
                    title: this.$t('tips.jumpTipsTitle'),
                    message: this.$t('tips.jumpTipsContent'),
                    confirmButtonText: this.$t('common.confirm'),
                    cancelButtonText: this.$t('common.cancel'),
                })
                    .then(() => {
                        // on confirm
                        window.location.href = link;
                    })
                    .catch(() => {
                        // on cancel
                    });
            } else {
                this.$toast.fail(this.$t('tips.linkInvalid'));
            }
        },
        showSheet() {
            this.$emit('showSheet', {
                address: this.cropInfo.address || "",
                code: this.cropInfo.code || "",
            });
        },
        handleImage(image) {
            return validateImageUrl(image);
        },
    },
};
</script>

<style scoped>
.cropItemBox {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr;
    grid-column-gap: 18px;
}

.cropItemVariety {
    width: 100%;
    height: 72px;
    border-radius: 5px;
    background: linear-gradient(90deg, rgba(42, 130, 228, 1) 0%, rgba(0, 64, 154, 1) 100%);
    box-shadow: 0px 2px 2px rgba(16, 16, 16, 0.05);
    padding: 13px 17px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 5px;
    font-size: 15px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
}

.cropItemName {
    width: 100%;
    height: 72px;
    border-radius: 5px;
    background: linear-gradient(90deg, rgba(255, 141, 26, 1) 0%, rgba(212, 48, 48, 1) 100%);
    box-shadow: 0px 2px 2px rgba(16, 16, 16, 0.05);
    padding: 13px 17px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 5px;
    font-size: 15px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
}

.cropItemIcon {
    width: 35px;
    height: 35px;
}

.cropItemText {
    flex: 1;
    overflow: hidden;
    max-width: 84px;
    text-align: center;
}

.cropBottomItem {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 20px;
    column-gap: 3px;
}

.cropBottomItem:last-child {
    margin-bottom: 0;
}

.cropBottomItemTitle {
    width: 92px;
    font-size: 12px;
    font-weight: 700;
    color: var(--h5-color-gray);
}

.cropBottomItemValue {
    flex: 1;
    font-size: 12px;
    color: var(--h5-color-blue);
}
</style>